<div class="tw:w-full tw:px-[15px] tw:mx-auto tw:h-full">
  <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:h-full master-container">

    @if (upcomingSessions.length > 0) {
      <div class="tw:w-full tw:px-[15px]">
        <div class="sh__flex-title">
          <div>
            <h3>Upcoming Sessions</h3>
          </div>
          <div>
            @if (showDigitalClassroomButtons) {
              <div>
                <h4>Digital Classroom</h4>
                <div class="sh__flex-buttons">
                  <button type="button" class="btn btn-outline-primary btn-rounded tw:my-0 tw:mx-1 btn-student"
                  (click)="launchNetworkTest()">Network Test</button>
                  <button type="button" class="btn btn-outline-primary btn-rounded tw:my-0 tw:mx-1 btn-student"
                  (click)="launchBrowerTest()">Browser Test</button>
                  <button type="button" class="btn btn-primary btn-rounded btn-student"
                  (click)="launchVideoLibrary()">Launch Video Library</button>
                </div>
              </div>
            }
          </div>
        </div>
        <div class="flex-row">
          <div class="flex-column">
            <app-data-table
              [columns]="columns"
              [data]="upcomingSessions"
              emptyMessage="You currently have no upcoming session(s) scheduled">
              <ng-template appColumnCell="sessionTime" let-element>
                {{element.startTime.slice(0, -3)}} - {{element.endTime.slice(0, -3)}}
              </ng-template>
              <ng-template appColumnCell="actions" let-element>
                <button type="button" class="btn btn-primary btn-rounded btn-sm tw:my-0 tw:mx-1"
                  [disabled]="element.disableLaunchButton" (click)="launchSession(element)">Launch Session</button>
              </ng-template>
            </app-data-table>
            @if (brambleEnabled) {
              <div class="tw:w-full tw:px-[15px] tw:mx-auto tw:text-left">
                <label class="">If you are unable to open the URL in a new tab please copy and paste this link:
                {{availableSessionLink}}</label>
              </div>
            }
          </div>
        </div>
        @if (launchSessionClicked) {
          <div class="flex-row">
            <div class="flex-column tw:text-left">
              <label>If your online session has not launched in a new tab, please copy and paste this url <span
              class="text-primary-colour">{{sessionUrl}}</span> into a new tab.</label>
            </div>
          </div>
        }
      </div>
    }

    @if (upcomingSessions.length == 0) {
      <div class="tw:w-full tw:px-[15px] tw:mx-auto tw:py-6 not-found-container">
        <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:justify-center tw:items-center">
          <div class="tw:w-full tw:px-[15px] tw:py-2 sh__flex-title">
            <h3 class="not-found-header">Upcoming Sessions</h3>
            @if (showLaunchVideoLibrary) {
              <button type="button" class="btn btn-primary btn-rounded btn-sm"
              (click)="launchVideoLibrary()">Launch Video Library</button>
            }
          </div>
          <div class="tw:w-full tw:px-[15px] tw:py-2 tw:flex tw:justify-center tw:items-center">
            <label class="not-found-sub-text">You currently have no upcoming session(s) scheduled</label>
          </div>
          <div class="tw:w-full tw:px-[15px] tw:py-2 tw:flex tw:justify-center tw:items-center">
            <label class="not-found-sub-text">please come back later</label>
          </div>
        </div>
      </div>
    }
  </div>
</div>